import { render, staticRenderFns } from "./widget_preview_message.vue?vue&type=template&id=863fb2dc&scoped=true"
import script from "./widget_preview_message.vue?vue&type=script&lang=ts"
export * from "./widget_preview_message.vue?vue&type=script&lang=ts"
import style0 from "./widget_preview_message.vue?vue&type=style&index=0&id=863fb2dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863fb2dc",
  null
  
)

export default component.exports